import { supabase } from '../lib/supabase'

/** Formato nazionale: IT + 3 cifre distributore + E + 8 caratteri. */
const FORMATO_POD = /^IT\d{3}E[A-Z0-9]{8}$/

export function validaCodicePod(codice: string): boolean {
  return FORMATO_POD.test(codice.trim().toUpperCase())
}

export interface ContatoreConPod {
  readonly id: number
  readonly codice: string
  readonly matricola: string
  readonly pod: ReadonlyArray<{ id: number; codicePod: string }>
}

export async function elencaContatoriConPod(impiantoId: number): Promise<ContatoreConPod[]> {
  const { data, error } = await supabase
    .from('contatore')
    .select('id, codice, matricola, pod(id, codice_pod)')
    .eq('impianto_id', impiantoId)
  if (error) throw new Error(error.message)
  return (data ?? []).map((r: Record<string, unknown>) => ({
    id: r.id,
    codice: r.codice,
    matricola: r.matricola,
    pod: ((r.pod as Record<string, unknown>[]) ?? []).map((p) => ({ id: p.id, codicePod: p.codice_pod })),
  })) as ContatoreConPod[]
}

export async function associaPod(contatoreId: number, codice: string): Promise<void> {
  const normalizzato = codice.trim().toUpperCase()
  if (!validaCodicePod(normalizzato)) throw new Error('Codice POD non valido')
  const { error } = await supabase.from('pod').insert({ contatore_id: contatoreId, codice_pod: normalizzato })
  if (error) throw new Error(error.message)
}

export async function rimuoviPod(id: number): Promise<void> {
  const { error } = await supabase.from('pod').delete().eq('id', id)
  if (error) throw new Error(error.message)
}
